import api from '../api'

const baseUrl = '/academy/api/AdminCourse'

const skillUpCourseSessionProvider = {
  getAllCourseSessions(params) {
    return api.get(`${baseUrl}/GetSession/${params}`)
  },

  getCourseSession(id) {
    return api.get(`${baseUrl}/GetSession/${id}`)
  },

  addCourseSession(params) {
    return api.post(`${baseUrl}/Session`, params)
  },

  updateCourseSession(params = {}) {
    return api.put(`${baseUrl}/Session`, params)
  },

  deleteCourseSession(params = {}) {
    return api.delete(`${baseUrl}/Session/${params}`)
  },

  addCourseSessionFile(params) {
    return api.post(`${baseUrl}/SessionFile`, params)
  },

  updateCourseSessionFile(params) {
    return api.put(`${baseUrl}/SessionFile`, params)
  },

  deleteCourseSessionFile(params = {}) {
    return api.delete(`${baseUrl}/SessionFile/${params}`)
  },
  updateCourseHeadlineOrder(params) {
    return api.put(`${baseUrl}/SessionOrder`, params)
  },

  // generateToken() {
  //   return api.get('/BizSchool/api/Home/Token')
  // },
}

export default skillUpCourseSessionProvider
